import { gql } from '@apollo/client';

const fragments = {
  weeklyWorkSummaryStats: gql`
    fragment WeeklyWorkSummaryStats on WeeklyWorkSummary {
      numPlanned
      numClaimed
      unclaimedHours
      claimedHours
    }
  `,
  weeklyWorkSummaryMilestoneCounts: gql`
    fragment WeeklyWorkMilestoneCounts on WeeklyWorkSummary {
      milestoneCountsByType {
        milestoneType {
          id
          name
          commodityTypes {
            id
            name
          }
        }
        numMilestones
      }
    }
  `,
};

export const GET_WORKLIST_DATA = gql`
  query weeklyWorkList($input: WeeklyWorkInput!, $paging: PagingRowNumberInput) {
    weeklyWorkList(input: $input, paging: $paging) {
      total
      rowNumber
      items {
        id
        name
        hours
        plannedEndDate
        plannedStartDate
        weekNumber
        attachments {
          id
          url
          createdAt
          creator {
            id
            firstName
            lastName
            persona
            imageUrl
          }
        }
        blocks {
          id
          type {
            id
            title
            description
          }
          comments {
            id
            comment
          }
          currentStatusI18n
          statusHistory {
            id
            codeI18n
            createdAt
          }
        }
        currentStatus {
          id
          codeI18n
          rejectionType {
            id
            reason
          }
          comments
          createdAt
          createdBy {
            id
            firstName
            lastName
          }
        }
        quantity {
          quantity
          unitOfMeasure
        }
        type {
          id
          name
          projectItrConfig {
            id
            itrType
          }
        }
        weldStatuses {
          id
          tag
          status {
            id
            status
            statusAt
            statusBy {
              id
              firstName
              lastName
            }
          }
          commodityAssignees {
            assignee {
              id
              firstName
              lastName
              imageUrl
              persona
            }
            personaType
          }
          type {
            id
            name
          }
        }
        commodity {
          materialCommodity {
            id
            tag
            workPackage {
              id
              tag
              facilities {
                id
              }
              primaryOwners {
                persona
                crewMember {
                  id
                  firstName
                  lastName
                  imageUrl
                  shiftType
                }
              }
              secondaryOwners {
                persona
                crewMember {
                  id
                }
              }
              otherOwners {
                persona
                crewMember {
                  id
                }
              }
            }
            type {
              id
              name
            }
          }
          weld {
            id
            tag
            commodityAssignees {
              assignee {
                id
                firstName
                lastName
                persona
                imageUrl
                shiftType
                discipline
              }
              personaType
            }
            workPackage {
              id
              tag
              facilities {
                id
              }
              primaryOwners {
                persona
                crewMember {
                  id
                  firstName
                  lastName
                  imageUrl
                  shiftType
                  crew {
                    id
                    crewNumber
                  }
                }
              }
              secondaryOwners {
                persona
                crewMember {
                  id
                }
              }
              otherOwners {
                persona
                crewMember {
                  id
                }
              }
            }
            type {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const GET_WORKLIST_SUMMARY_STATS = gql`
  query weeklyWorkSummaryStats($input: WeeklyWorkInput!) {
    weeklyWorkSummary(input: $input) {
      ...WeeklyWorkSummaryStats
    }
    ${fragments.weeklyWorkSummaryStats}
  }
`;

export const GET_WORKLIST_SUMMARY_MILESTONES = gql`
  query weeklyWorkSummaryMilestones($input: WeeklyWorkInput!) {
    weeklyWorkSummary(input: $input) {
      ...WeeklyWorkMilestoneCounts
    }
    ${fragments.weeklyWorkSummaryMilestoneCounts}
  }
`;
export const GET_PENDING_APPROVAL_LIST_SUMMARY_STATS = gql`
  query pendingApprovalSummary($input: PendingApprovalInput!) {
    pendingApprovalSummary(input: $input) {
      pendingApprovalHours
      approvedHours
    }
  }
`;

export const GET_BULK_WEEKLY_WORKLIST_DATA = gql`
  query weeklyWorkListBulk($input: WeeklyWorkInput!, $paging: PagingRowNumberInput) {
    weeklyWorkListBulk(input: $input, paging: $paging) {
      total
      rowNumber
      items {
        id
        milestoneType
        quantityHours
        commodityType
        tag
        workPackageNumber
        foreman
        generalForeman
        superintendent
        planWeekNumber
      }
    }
  }
`;
